import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://caoliu-tech.com${item.href}` : undefined,
    })),
  };

  const categoryMap = categories.reduce<Record<string, string>>((acc, cat) => {
    acc[cat.slug] = cat.name;
    return acc;
  }, {});

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const label = categoryMap[item.label] || item.label;

          return (
            <span key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <span className="text-foreground-300">/</span>
              )}
              {isLast || !item.href ? (
                <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                  {label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {label}
                </Link>
              )}
            </span>
          );
        })}
      </nav>
    </>
  );
}